// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-docs-js": () => import("/Users/dawid/Projects/DS/dsplatform-documentation/src/templates/docs.js" /* webpackChunkName: "component---src-templates-docs-js" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "/Users/dawid/Projects/DS/dsplatform-documentation/.cache/data.json")

